<p-card [ngClass]="{'task-gray-overlay': isDisabled }">
  <div style="padding: .3em">
    <div class="task-name">
      {{task.name}}: {{treeTypes}}@if (task.isGoBack) {
      <span> - GB</span>
    }
  </div>
  @if (!task.isGoBack) {
    <div class="task-info">
      @if (showPrice) {
        <span>{{task.price | currency}} <i class="pi pi-circle-on" style="font-size: .5em;"></i> </span>
        }{{task.hours}} {{unit}}
        @if (task.completionStatus == 'Completed') {
          <i class="pi pi-check middle-this" pTooltip="Task is Complete"></i>
        }
        @if (task.completionStatus == 'Unable to be Completed') {
          <i class="pi pi-info-circle middle-this" pTooltip="Task will not be completed"></i>
        }
      </div>
    }
    @if (task.isGoBack) {
      <div class="task-info">
        <span>$0.00 <i class="pi pi-circle-on" style="font-size: .5em;"></i> </span>{{task.goBackHoursEstimate}} {{goBackUnit}}
        @if (task.completionStatus == 'Completed') {
          <i class="pi pi-check middle-this" pTooltip="Task is Complete"></i>
        }
        @if (task.completionStatus == 'Unable to be Completed') {
          <i class="pi pi-info-circle middle-this" pTooltip="Task will not be completed"></i>
        }
      </div>
    }
  </div>
</p-card>